// Types used for the API

export enum WEBSOCKET_URL {
  RESTAURANT_ORDERS = "/restaurant/orders",
  ORDER_STATUS = "/order/status",
}
